import React from 'react';
import { Gift, Check, MessageSquareText, FileText, Bot } from 'lucide-react';
import { motion } from 'framer-motion';
const bonuses = [{
  icon: MessageSquareText,
  label: 'BONO 1',
  title: 'Qué decir cuando te cuestionan el precio',
  value: '$12.000',
  intro: 'Aprendé a hablar de tu precio sin perder al cliente.',
  items: ['Entendé cómo decide un cliente', 'Mostrá el alcance antes de hablar de precio', 'Sostené tu precio cuando te piden descuento', 'Comunicá aumentos sin romper la relación']
}, {
  icon: FileText,
  label: 'BONO 2',
  title: 'Scripts para reuniones y mensajes',
  value: '$9.000',
  intro: 'Usá palabras claras en cada conversación importante.',
  items: ['Empezá una primera reunión con claridad', 'Respondé “me parece caro” sin bajar el precio', 'Comunicá un aumento de honorarios', 'Cerrá acuerdos sin hacer descuentos', 'Respondé las objeciones más comunes']
}, {
  icon: Bot,
  label: 'BONO 3',
  title: 'Usá IA para ahorrar tiempo',
  value: '$9.000',
  intro: 'Resolvé tareas repetidas y usá ese tiempo mejor.',
  items: ['Usá prompts para tareas comunes', 'Prepará propuestas e informes más rápido', 'Pedile ayuda a la IA sin perder control', 'Armá una semana de trabajo más simple']
}];
export function BonusStack() {
  return <section className="bg-white px-6 py-24 lg:px-8" data-id="element-27">
      <div className="mx-auto max-w-6xl" data-id="element-28">
        <header className="mb-12 text-center" data-id="element-29">
          <div className="mb-5 inline-flex h-14 w-14 items-center justify-center rounded-full bg-brand-gold/10" data-id="element-30">
            <Gift className="h-7 w-7 text-brand-gold" data-id="element-31" />
          </div>
          <h2 className="text-3xl font-extrabold text-brand-navy md:text-5xl" data-id="element-32">
            Sumá herramientas para cobrar mejor
          </h2>
        </header>

        <div className="grid gap-6 lg:grid-cols-3" data-id="element-33">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.label} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="flex flex-col rounded-3xl border border-brand-light bg-brand-lighter p-6" data-id="element-34">
                <div className="mb-5 flex items-center justify-between" data-id="element-35">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-brand-accent shadow-sm" data-id="element-36">
                    <Icon className="h-5 w-5" data-id="element-37" />
                  </div>
                  <span className="rounded-full bg-brand-gold/15 px-3 py-1 text-xs font-extrabold text-brand-gold" data-id="element-38">
                    {bonus.label}
                  </span>
                </div>
                <h3 className="text-xl font-extrabold leading-snug text-brand-navy" data-id="element-39">
                  {bonus.title}
                </h3>
                <p className="my-4 text-sm leading-relaxed text-brand-navy/70" data-id="element-40">
                  {bonus.intro}
                </p>
                <ul className="mb-6 space-y-3 text-sm text-brand-navy/80" data-id="element-41">
                  {bonus.items.map(item => <li key={item} className="flex gap-2" data-id="element-42">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" data-id="element-43" />
                      {item}
                    </li>)}
                </ul>
                <div className="mt-auto border-t border-brand-light pt-4 text-sm font-extrabold text-brand-green" data-id="element-44">
                  {bonus.value} incluido
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}